<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-accordion [multiple]="false" (onOpen)="abrirAcordeon($event)">
        <p-accordionTab header="{{ 'SEGMENTOS.LBL_HEADER' | translate}}" [selected]="tabSeleccionado === 'INFO'">
          <form [formGroup]="formulario" (ngSubmit)="onSubmit()">
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label for="codigo">* {{ 'LBL_CODIGO' | translate}}</label>
                  <input type="text" id="codigo" name="codigo" pInputText formControlName="codigo"
                         maxlength="6"
                         (blur)="validarCodigo()" codigos-reactive/>
                  <div class="p-message p-messages-error p-corner-all"
                       *ngIf="submitted && f.codigo.invalid">
                    {{ 'SEGMENTOS.MSG_CODREQUERIDO' | translate}}
                  </div>
                  <div class="p-message p-messages-error p-corner-all"
                       *ngIf="codExiste">
                    {{ 'SEGMENTOS.MSG_CODIGOEXISTE' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label for="nombre">* {{ 'LBL_NOMBRE' | translate}}</label>
                  <input type="text" id="nombre" name="nombre" pInputText maxlength="45" formControlName="nombre"/>
                  <div class="p-message p-messages-error p-corner-all"
                       *ngIf="submitted && f.nombre.invalid">
                    {{ 'SEGMENTOS.MSG_NOMREQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 p-mg-12 lg:col-12">
                <div class="div-form">
                  <label for="descripcion">{{ 'LBL_DESCRIPCION' | translate}}</label>
                  <textarea pInputTextarea id="descripcion" name="descripcion" formControlName="descripcion"
                            maxlength="1000"
                  ></textarea>
                </div>
              </div>
            </div>

            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'SEGMENTOS.LBL_TIPOOCUPACION' | translate }}</label>
                  <div
                    *ngIf="(!f.idTipoOcupacionConfiguracion.value && !f.idSegmento.value) || (!f.idSegmento.value && f.idTipoOcupacionConfiguracion.value)">
                    <p-dropdown disableTab  id="idTipoOcupacion" name="nomTipoOcupacion" [options]="lisOcupaciones" filter="filter"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                optionValue="value"
                                optionLabel="label"
                                 formControlName="idTipoOcupacionConfiguracion"
                                (onChange)="cambioOcupacion($event)"
                    ></p-dropdown>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoOcupacionConfiguracion.invalid">
                      {{ 'SEGMENTOS.LBL_TIPOOCUPACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                  <label *ngIf="f.idTipoOcupacionConfiguracion.value&&f.idSegmento.value"
                         class="falso-combo-texto">{{f.nombreTipoOcupacion.value}}</label>
                </div>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6" *ngIf="tipOcupacionSeleccionada&& tipOcupacionSeleccionada.indicadorEmpleador">
                <div class="div-form">
                  <label>* {{ 'SEGMENTOS.LBL_EMPLEADOR' | translate }}</label>
                  <div *ngIf="!f.indicadorHabilitado.value">
                    <p-dropdown disableTab  id="indicadorEmpleador" name="nomEmpleador" [options]="lisEmpleador"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                                 formControlName="indicadorEmpleador"
                    ></p-dropdown>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.indicadorEmpleador.invalid">
                      {{ 'SEGMENTOS.LBL_EMPLEADOR' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                  <label *ngIf="f.indicadorHabilitado.value"
                         class="falso-combo-texto">{{f.indicadorEmpleador.value === true ? 'Si' : f.indicadorEmpleador.value === false ? 'No' : 'N/A'}}</label>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6" *ngIf="tipOcupacionSeleccionada&& tipOcupacionSeleccionada.indicadorUnidadProductiva">
                <div class="div-form">
                  <label>* {{ 'SEGMENTOS.LBL_TIENEUP' | translate }}?</label>
                  <div *ngIf="!f.indicadorHabilitado.value">
                    <p-dropdown disableTab  id="indicadorTieneUP" name="nomTieneUP" [options]="lisUnidadProductiva"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                                 formControlName="indicadorUnidadProductiva"
                    ></p-dropdown>
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.indicadorUnidadProductiva.invalid">
                      {{ 'SEGMENTOS.LBL_TIENEUP' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                  <label *ngIf="f.indicadorHabilitado.value"
                         class="falso-combo-texto">{{f.indicadorUnidadProductiva.value === true ? 'Si' : f.indicadorUnidadProductiva.value === false ? 'No' : 'N/A'}}</label>
                </div>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label for="codigoShivam">* {{ 'SEGMENTOS.LBL_CODIGOSHIVAM' | translate}}</label>
                  <input type="text" id="codigoShivam" name="codigoShivam" pInputText formControlName="codigoShivam"
                         maxlength="6"
                         (blur)="validarCodigoShivam()" codigos-reactive/>
                  <div class="p-message p-messages-error p-corner-all"
                       *ngIf="submitted && f.codigoShivam.invalid">
                    {{ 'SEGMENTOS.MSG_CODREQUERIDO' | translate}}
                  </div>
                  <div class="p-message p-messages-error p-corner-all"
                       *ngIf="codShivamExiste">
                    {{ 'SEGMENTOS.MSG_CODIGOEXISTE' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 p-mg-6 lg:col-6">
                <div class="div-form">
                  <p-checkbox binary="true" id="indicadorContinuarVisita" name="indicadorContinuarVisita"
                              label="{{ 'SEGMENTOS.LBL_CONTINUARVISITA' | translate}}"
                              formControlName="indicadorContinuarVisita"></p-checkbox>
                </div>
              </div>
            </div>

            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <img *ngIf="!carImagen && imagen" style="height: 100px" [src]="imagen" alt=""/>
                <div *ngIf="f.idAdjunto.value && !carImagen" class="btn-group" role="group" style="display: block;">
                  <label class="btn btn-default" style="max-width: 87%; overflow: hidden;">
                    <i class="fa fa-file-o" aria-hidden="true"></i>
                    {{nomArchivo}}
                  </label>
                  <a class="btn btn-danger" (click)="cancelarAdjunto()" style="padding: 3px; border-radius: 5px;">
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </a>
                </div>
                <p-fileUpload name="file" url="{{svcThUrl}}" [auto]="false" class="upload-avatar"
                              chooseLabel="{{'SEGMENTOS.LBL_SUBIRIMAGEN' | translate}}" #adjunto
                              (onBeforeUpload)="onBeforeSend($event)" mode="basic" [hidden]="carImagen"
                              (onValidSelect)="onSelect($event, $event.files)"
                              invalidFileTypeMessageSummary="{0} {{'LBL_FILETIPO' | translate}}."
                              invalidFileTypeMessageDetail="{{'SEGMENTOS.LBL_FILETIPOES' | translate}}"
                              (onUpload)="onUpload($event)" accept="image/*" fSize
                ></p-fileUpload>
                <div *ngIf="carImagen" class="col-12 flex align-items-center justify-content-center">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                  <span>{{'LBL_CARGANDO' | translate }}</span>
                </div>
              </div>
            </div>


            <div class="grid form-footer-buttons gap-2">
              <div class="form-group col-12" *ngIf="!guardando">
                <a (click)="goBack()" class="cancelar">{{ 'BTN_CANCELAR' | translate }}</a>
                <button pButton icon="fa fa-plus" label="{{ 'BTN_GUARDAR' | translate}}" type="submit"></button>
              </div>
              <div class="form-group col-12 flex align-items-center justify-content-center" *ngIf="guardando">
                <i class="fa fa-refresh fa-spin fa-fw"></i>
                <span>{{ 'LBL_GUARDANDO' | translate}}...</span>
              </div>
            </div>
          </form>
        </p-accordionTab>
        <p-accordionTab header="{{ 'SEGMENTOSOCUPACIONES.LBL_ASIGNARPARAMETROS' | translate}}"
                        [selected]="tabSeleccionado === 'OCUPACION'"
                        [disabled]="!segmento">
          <p-tabView (onChange)="cambioTabSeleccionado($event.index)" *ngIf="tipOcupacionSeleccionada">
            <p-tabPanel header="{{ 'SEGMENTOSOCUPACIONES.LBL_OCUPACIONES' | translate}}"
                        *ngIf="tipOcupacionSeleccionada.indicadorTipoOcupacion && f.idSegmento.value">
              <app-segmento-ocupaciones [segmento]="segmento"></app-segmento-ocupaciones>
            </p-tabPanel>
            <p-tabPanel header="{{ 'SEGMENTOSOCUPACIONES.LBL_ACTIVIDADES' | translate}}"
                        *ngIf="tipOcupacionSeleccionada.indicadorManejaActividades && f.idSegmento.value">
              <app-segmento-actividades [segmento]="segmento"
                                        *ngIf="carSeccionesOcupaciones.actividad"></app-segmento-actividades>
            </p-tabPanel>
            <p-tabPanel header="{{ 'SEGMENTOSOCUPACIONES.LBL_INGRESOS' | translate}}"
                        *ngIf="tipOcupacionSeleccionada.indicadorIngresos && f.idSegmento.value">
              <app-segmento-ingresos [segmento]="segmento" [segmentoTemp]="segmentoTemp"></app-segmento-ingresos>
            </p-tabPanel>
            <p-tabPanel header="{{ 'SEGMENTOSOCUPACIONES.LBL_NIVELENDEUDAMIENTO' | translate}}"
                        *ngIf="tipOcupacionSeleccionada.indicadorNivelEndeudamiento && f.idSegmento.value">
              <app-segmento-endeudamiento [segmento]="segmento" [segmentoTemp]="segmentoTemp" [constanteNIVEND]="constanteNIVEND"></app-segmento-endeudamiento>
            </p-tabPanel>
            <p-tabPanel header="{{ 'SEGMENTOSOCUPACIONES.LBL_ACTIVOS' | translate}}"
                        *ngIf="tipOcupacionSeleccionada.indicadorActivos && f.idSegmento.value">
              <app-segmento-activos [segmento]="segmento" [segmentoTemp]="segmentoTemp"></app-segmento-activos>
            </p-tabPanel>
            <p-tabPanel header="{{ 'SEGMENTOSOCUPACIONES.LBL_EMPLEADOS' | translate}}"
                        *ngIf="tipOcupacionSeleccionada.indicadorNumeroEmpleados && f.idSegmento.value">
              <app-segmento-empleados [segmento]="segmento" [segmentoTemp]="segmentoTemp"></app-segmento-empleados>
            </p-tabPanel>
            <p-tabPanel header="{{ 'SEGMENTOSOCUPACIONES.LBL_SECTOR' | translate}}"
                        *ngIf="tipOcupacionSeleccionada.indicadorSector && f.idSegmento.value">
              <app-segmento-sector [segmento]="segmento" [segmentoTemp]="segmentoTemp"></app-segmento-sector>
            </p-tabPanel>
            <p-tabPanel header="{{ 'SEGMENTOSOCUPACIONES.LBL_TIPOCONTRATO' | translate}}"
                        *ngIf="tipOcupacionSeleccionada.indicadorTipoContrato && f.idSegmento.value">
              <app-segmento-tipo-contrato [segmento]="segmento" [segmentoTemp]="segmentoTemp"></app-segmento-tipo-contrato>
            </p-tabPanel>
          </p-tabView>
        </p-accordionTab>
        <p-accordionTab header="{{ 'SEGMENTOSPRODUCTOS.LBL_HEADER' | translate}}" [selected]="tabSeleccionado === 'PRODUCTO'"
                        [disabled]="!segmento">
          <app-segmento-productos [segmento]="segmento" *ngIf="segmento && segmento.idSegmento"></app-segmento-productos>
        </p-accordionTab>
        <p-accordionTab header="{{ 'SEGMENTOTIPOVINCULACION.LBL_TIPOVINCULACION' | translate}}"
                        [selected]="tabSeleccionado === 'TIPOVINCULACION'"
                        [disabled]="!segmento">
          <app-segmento-tipo-vinculacion [segmento]="segmento" *ngIf="segmento && segmento.idSegmento"></app-segmento-tipo-vinculacion>
        </p-accordionTab>
        <div class="grid form-footer-buttons">
          <div class="form-group col-12 gap-2" *ngIf="!validandoSegmento">
            <button pButton icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate}}" type="button" (click)="goBack()"></button>
            <button pButton icon="fa fa-check " label="{{ 'SEGMENTOS.BTN_HABILITARSEGMENTO' | translate}}" type="button"
                    (click)="habilitarSegmento()"
                    *ngIf="f.idSegmento.value && !f.indicadorHabilitado.value"></button>
            <button pButton icon="fa fa-check " label="{{ 'SEGMENTOS.BTN_INHABILITARSEGMENTO' | translate}}" type="button"
                    (click)="habilitarSegmento()"
                    *ngIf="f.idSegmento.value && f.indicadorHabilitado.value"></button>
          </div>
          <div class="form-group col-12 flex align-items-center justify-content-center" *ngIf="validandoSegmento">
            <i class="fa fa-refresh fa-spin fa-fw"></i>
            <span>{{ 'LBL_GUARDANDO' | translate}}...</span>
          </div>
        </div>
      </p-accordion>
    </div>
  </div>
</div>

<p-confirmDialog #cd key="segmento">
  <ng-template pTemplate="footer" class="gap-2">
    <button type="button" pButton icon="fa fa-close" label="{{ 'BTN_NO' | translate}}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'BTN_SI' | translate}}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
<p-dialog header="{{ 'SEGMENTOS.LBL_ASIGNARMONTO' | translate }}" [(visible)]="valorVenta" *ngIf="valorVenta"
          [positionTop]="100" responsive="true" modal="true">
  <form [formGroup]="formularioVenta" (ngSubmit)="onSubmitValorVenta()">
    <div class="grid form-group">
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'SEGMENTOS.LBL_MONTOMINIMO' | translate }}</label>
          <input type="text" pInputText id="idMinimo"
                 name="nomMinimo"
                 autocomplete="off"
                 maxlength="20"
                 formControlName="montoMinimo"
                 (blur)="validarValor($event, true)"
                 currencyMask
                 [options]="{ prefix: '$ ', thousands: appSettingService.separadorMiles, decimal: appSettingService.separadorDecimales, allowNegative:false, precision : 2 }"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submittedVenta && fv.montoMinimo.invalid">
            {{ 'SEGMENTOS.LBL_MONTOMINIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
          <div class="p-message p-messages-error p-corner-all" *ngIf="!rangoDesdeValido">
            {{ 'SEGMENTOS.LBL_MONTOMINIMOSUPERA' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'SEGMENTOS.LBL_MONTOMAXIMO' | translate }}</label>
          <input type="text" pInputText id="idMAXIMO"
                 name="nomMaximo"
                 autocomplete="off"
                 formControlName="montoMaximo"
                 (blur)="validarValor($event, false)" currencyMask
                 [options]="{ prefix: '$ ', thousands: appSettingService.separadorMiles, decimal: appSettingService.separadorDecimales, align: 'left', allowNegative:false, precision : 2 }"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submittedVenta && fv.montoMaximo.invalid">
            {{ 'SEGMENTOS.LBL_MONTOMAXIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
    </div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12 gap-2">
        <div *ngIf="!guardandoVenta">
          <button icon="fa fa-plus"
                  label="{{'BTN_AGREGAR' | translate }}"
                  type="submit"
                  pButton></button>
        </div>
        <div *ngIf="guardandoVenta" class="col-12 flex align-items-center justify-content-center">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>
  </form>
</p-dialog>

